import { Text, StyleSheet, TouchableOpacity } from "react-native";

export const Title = ({ children, orientation, stepState: { isCompleted, isActive } }: any) => {
	return (
		<TouchableOpacity>
			<Text style={styles(isCompleted, isActive, orientation).stepperTitle}>{children}</Text>
		</TouchableOpacity>
	);
};

const styles = (isCompleted: any, isActive: any, orientation: any) =>
	StyleSheet.create({
		stepperTitle: {
			fontFamily: "Nunito",
			fontWeight: "400",
			color: "rgba(242, 242, 242, 1)",
			opacity: isCompleted || isActive ? 1 : 0.4,
			alignItems: "center",
			fontSize: orientation === "vertical" ? 14 : 18,
			lineHeight: orientation === "vertical" ? 16 : 20,
			marginTop: orientation === "vertical" ? 0 : -55,
		},
	});
